"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Surface = Surface;
var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));
var _UiThemeProvider = require("../theme/UiThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Elevation-aware themed container — the base building block for cards,
 * sections, and modal surfaces on both platforms.
 */
function Surface({
  children,
  variant = 'card',
  elevation = 0,
  bordered = false,
  radius = 'medium',
  style,
  ...rest
}) {
  const theme = (0, _UiThemeProvider.useUiTheme)();
  const backgroundColor = {
    card: theme.palette.card,
    cardStrong: theme.palette.cardStrong,
    section: theme.palette.section,
    modal: theme.palette.modalCard
  }[variant];
  const level = theme.elevations[`e${elevation}`];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ...rest,
    style: [{
      backgroundColor,
      borderRadius: theme.radius[radius],
      ...(bordered ? {
        borderWidth: 1,
        borderColor: theme.palette.border
      } : null),
      ...level.native
    }, style],
    children: children
  });
}